import { useBrokerFeature } from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { PropertyDetailApplicationsContainer as RentMatchContainer } from "../ApplicationsRentmatch/PropertyDetailApplicationsContainer";
import { PropertyDetailApplicationsContainer as LegacyContainer } from "./PropertyDetailApplicationsContainer";

export const ApplicationsRouter = () => {
  const hasRentMatch = useBrokerFeature(EBrokerFeature.RentMatch);

  if (hasRentMatch) {
    return <RentMatchContainer />;
  }

  return <LegacyContainer />;
};
